import React, { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import useReviews from "../../Context/Reveiws/useReviews";
import ShowReviewCard from "./ShowReviewCard";

const ShowReview = () => {
  const [reviews, setReviews] = useState([]);
  const serviceDetailData = useLoaderData();
  console.log("service data",serviceDetailData._id);
    useEffect(()=>{
        fetch(`https://spooky-journalist-server.vercel.app/reviews/${serviceDetailData._id}`)
        .then(res => res.json())
        .then(data => setReviews(data))

       
    },[])
  // console.log(reviews);
  return (
    <div>
     
      <h1 className="text-3xl font-medium title-font text-gray-900 mb-12 text-center">
        Happy Clients
      </h1>

      <div className="flex flex-wrap -m-4 container mx-auto">
        {reviews.map((review) => (
          <ShowReviewCard key={review._id} review={review}></ShowReviewCard>
        ))}
      </div>
    </div>
  );
};

export default ShowReview;
